<template>
  <b-container fluid>
    <h1>Map</h1>
    <div v-if="loaded">
      <mio-map
        :method="MapData.method"
        :messages="MapData.messages"
        :data="MapData.data"
        :filters="MapData.filters"
      />
    </div>
    <h2 v-else>Loading...</h2>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex';
import { set, get, validateRow, formatPersonName } from '@/utils/MioHelpers';
import MioMap from '@/components/MioMap';

export default {
  name: 'SchoolsMap',
  components: {
    MioMap,
  },
  data() {
    return {
      loaded: false,
    }
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions({
      GET_COORDINATORS: "coordinators/GET_COORDINATORS",
      GET_SCHOOL_LOCATIONS: "mio/GET_SCHOOL_LOCATIONS",
    }),
    async getData() {
      try {
        await this.GET_COORDINATORS();
        await this.GET_SCHOOL_LOCATIONS();

        this.loaded = true;
      } catch (err) {
        console.error(err);
      }
    }
  },
  computed: {
    MapData: {
      get() {
        let input = {
          coordinators: this.$store.state.coordinators.coordinators,
          schoolLocations: this.$store.state.mio.schoolLocations,
        }
        let working = {
          areas: {},
          coordinators: {},
        };
        let output = {
          method: "",
          messages: [],
        };

        Object.keys(input.schoolLocations).forEach(index => {
          let [valid, message, country, region, district] = validateRow(input.schoolLocations[index], ['country', 'region', 'district']);
          if (!valid) {
            output.messages.push(`school location record is missing some data: ${message}`);
            return;
          }
          set(working, `areas.${country}.${region}.${district}`, {});
        });

        Object.keys(input.coordinators).forEach(index => {
          set(working, `coordinators.${input.coordinators[index].country}.${input.coordinators[index].uuid}`, formatPersonName(input.coordinators[index]));
        });

        output.filters = [{
          title: 'Areas',
          name: 'area',
          options: Object.keys(working.areas).sort().map(country => ({
            title: country,
            ID: country,
            options: Object.keys(working.areas[country]).sort().map(region => ({
              title: region,
              ID: `${country}.${region}`,
              options: Object.keys(working.areas[country][region]).sort().map(district => ({
                title: district,
                ID: `${country}.${region}.${district}`,
              })),
            })),
          })),
        },
        {
          title: 'Coordinators',
          name: 'coordinator',
          options: Object.keys(working.coordinators).sort().map(country => ({
            title: country,
            ID: country,
            options: Object.keys(working.coordinators[country]).sort().map(coordinator => ({
              title: working.coordinators[country][coordinator],
              ID: coordinator,
            })),
          })),
        }];

        output.data = Object.keys(input.schoolLocations).map(id => ({
          title: input.schoolLocations[id].school_name,
          lat: input.schoolLocations[id].lat,
          lng: input.schoolLocations[id].lng,
          filters: [{
            name: 'coordinator',
            values: [input.schoolLocations[id].country, input.schoolLocations[id].coordinator_uuid],
          },
          {
            name: 'area',
            values: [
              input.schoolLocations[id].country,
               `${input.schoolLocations[id].country}.${input.schoolLocations[id].region}`,
              `${input.schoolLocations[id].country}.${input.schoolLocations[id].region}.${input.schoolLocations[id].district}`
            ],
          }]
        }));

        // console.log(working);
        // console.log(output);
        return output;
      }
    }
  },
};
</script>
